import { createSvgIcon } from "@mui/material";

export const CloseIconArrow = createSvgIcon(
    <path
        d="M 22.4816 14.4736 C 22.6554 14.6441 22.6712 14.9108 22.529 15.0988 L 22.4816 15.1526 L 18.5572 18.9997 L 22.4816 22.8467 C 22.6554 23.0172 22.6712 23.2839 22.529 23.4719 L 22.4816 23.5257 C 22.3077 23.6962 22.0356 23.7117 21.8439 23.5722 L 21.789 23.5257 L 17.5184 19.3392 C 17.3446 19.1687 17.3288 18.902 17.471 18.714 L 17.5184 18.6602 L 21.789 14.4736 C 21.9802 14.2861 22.2903 14.2861 22.4816 14.4736 Z"
        fill="#7F7F7F"
    />,
    'CloseArrow',
);